<script setup>
import {onBeforeMount, reactive, ref} from 'vue'
import BoxUpload from "@/components/YTBoxUpload/index.vue"
import moment from "moment";
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import YTAddress from "@/components/YTAddress/index.vue";
import {addServiceLocation, detailServiceLocation, editServiceLocation} from "@/api/serviceLocation/serviceLocation.js";

const loading = ref(false)
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onBeforeMount(() => {
  isEdit.value = Boolean(route.query.locationId)
  if (isEdit.value) {
    getDetail(route.query.locationId)
  } else {
    // addOperatingTime()
  }
})
/*获取商店信息*/
const getDetail = async (locationId) => {
  loading.value = true
  try {
    const res = await detailServiceLocation(locationId)
    if (!res) throw new Error("null")
    Object.assign(ruleForm, res);
    ruleForm.operatingHours.map(item => {
      item.operatingTime = []
      console.log("moment().format(\"YYYY-MM-DD\") + ' ' + item.operatingStart", moment().format("YYYY-MM-DD") + ' ' + item.operatingStart)
      item.operatingTime[0] = moment(moment().format("YYYY-MM-DD") + ' ' + item.operatingStart).format()
      item.operatingTime[1] = moment(moment().format("YYYY-MM-DD") + ' ' + item.operatingEnd).format()
    })
    console.log("ruleForm", ruleForm)
    // 特殊处理地址反显
    let temp = []
    temp.push(ruleForm.provinceCode)
    temp.push(ruleForm.cityCode)
    temp.push(ruleForm.districtCode)
    ruleForm.showAddressCode = temp.join("/")
    handleReview(res.pictures)
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此服务地点数据",
        duration: 3000,
        onClose: () => {
          router.push("/listPost")
        }
      })
    }
  }
}
/*表单信息*/
// 表单大小
const formSize = ref('large')
// 表单锚点
const ruleFormRef = ref()
// 上传组件锚点
const boxUploadRef = ref()
// 表单信息
const ruleForm = reactive({
  locationName: null,
  locationNameEn: "Coming Soon ...",
  locationShortName: null,
  locationShortNameEn: "Coming Soon ...",
  locationType: null,
  phone: null,
  provinceCode: null,
  cityCode: null,
  districtCode: null,
  addressDetail: null,
  addressDetailEn: "Coming Soon ...",
  showAddressCode: null,
  pictures: [],
  operatingStart: null,
  operatingEnd: null,
  description: null,
  descriptionEn: "Coming Soon ...",
  operatingHours: [],
  nonSelfOperatedLink: null
})
// 校验表单 - 照片列表
const checkPictures = (rule, value, callback) => {
  if(boxUploadRef.value.fileList.length <= 0) return callback(new Error('请上传至少一张照片'))
  callback()
}
// 校验表单 - 营业时间
const checkOperatingHours = (rule, value, callback) => {
  if (ruleForm.operatingHours.length > 0) {
    console.log("校验规则：", ruleForm.operatingHours)
    ruleForm.operatingHours.map(item => {
      console.log("开始星期", item.weekdayOpen)
      console.log("开始星期布尔值", Boolean(!item.weekdayOpen))
      if (!item.weekdayOpen) {
        return callback(new Error("有开始星期未选择"))
      }
      if (!item.weekdayClose) {
        return callback(new Error("有结束星期未选择"))
      }
      if (!item.operatingTime[0] || !item.operatingTime[1]) {
        return callback(new Error("有营业时间未选择"))
      }
    })
  }
  return callback()
}
// 名称校验规则
const checkLocationName = (rule, value, callback) => {
  if (!ruleForm.locationName) {
    return callback(new Error("名称（中文）不能为空！"))
  }
  if (!ruleForm.locationNameEn) {
    return callback(new Error("名称（English）不能为空！"))
  }
  return callback()
}
// 简称校验规则
const checkLocationShortName = (rule, value, callback) => {
  if (!ruleForm.locationShortName) {
    return callback(new Error("简称（中文）不能为空！"))
  }
  if (!ruleForm.locationShortNameEn) {
    return callback(new Error("简称（English）不能为空！"))
  }
  return callback()
}
// 详细地址校验规则
const checkAddressDetail = (rule, value, callback) => {
  if (!ruleForm.addressDetail) {
    return callback(new Error("详细地址（中文）不能为空！"))
  }
  if (!ruleForm.addressDetailEn) {
    return callback(new Error("详细地址（English）不能为空！"))
  }
  return callback()
}
// 商品推荐校验规则
const checkDescription = (rule, value, callback) => {
  if (ruleForm.description && !ruleForm.descriptionEn) {
    return callback(new Error("商品推荐（English）不能为空！"))
  }
  return callback()
}
// 所属区域校验规则
const checkShowAddress = (rule, value, callback) => {
  if (!ruleForm.provinceCode || !ruleForm.cityCode) {
    return callback(new Error("请选择所属区域"))
  }
  return callback()
}
// 表单校验规则
const rules = reactive({
  locationName: [
    {required: true, validator: checkLocationName, trigger: 'blur'},
  ],
  locationShortName: [
    {required: true, validator: checkLocationShortName, trigger: 'blur'},
  ],
  locationType: [
    {required: true, message: "请选择类型", trigger: "change"}
  ],
  addressDetail: [
    {required: true, validator: checkAddressDetail, trigger: 'blur'}
  ],
  showAddressCode: [
    { required: true, validator: checkShowAddress, trigger: 'blur' }
  ],
  operatingHours: [
    {validator: checkOperatingHours, trigger: 'blur'}
  ],
  description: [
    {validator: checkDescription, trigger: 'blur'}
  ]
})
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createServiceLocation()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 服务地点类型枚举
const locationTypeEnum = [
  {
    label: "酒店",
    value: "HOTEL"
  },
]
// 创建服务地点
const createServiceLocation = async () => {
  console.log("ruleForm:", ruleForm)
  // 处理营业时间
  ruleForm.operatingHours.map(item => {
    item.operatingStart = moment(item.operatingTime[0]).format("HH:mm:ss")
    item.operatingEnd = moment(item.operatingTime[1]).format("HH:mm:ss")
    console.log("开始时间搜索结果", startDataOptions.value.find(i => i.value === item.weekdayOpen))
    if (typeof item.weekdayOpen === "number" || typeof item.weekdayClose === "number") {
      item.weekdayOpen = startDataOptions.value.find(i => i.value === item.weekdayOpen).label
      item.weekdayClose = startDataOptions.value.find(i => i.value === item.weekdayClose).label
    }
  })
  // 处理联系电话
  if (!ruleForm.phone) ruleForm.phone = null
  try {
    if (isEdit.value) {
      await editServiceLocation(ruleForm)
    } else {
      await addServiceLocation(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listServiceLocation')
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单信息
const resetForm = () => {
  router.back()
}

// 处理图片上传成功
const handlePicSuccess = (url) => {
  console.log("url", url)
  ruleForm.pictures = []
  ruleForm.pictures = url
  loading.value = false
}
// 处理图片反显
const handleReview = (reviewList) => {
  console.log("father handleReview", reviewList)
  boxUploadRef.value.handleReview(reviewList)
}
// 处理删除图片
const handlePicRemove = (url) => {
  ruleForm.pictures = url
}
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  const res = data.value.split("/")
  ruleForm.showAddressCode = data.value.split("/")
  ruleForm.provinceCode = res[0]
  ruleForm.cityCode = res[1]
  ruleForm.districtCode = res.length > 2 ? res[2] : null
  ruleFormRef.value.validateField("showAddress")
}

// 开始日期星期数组
const startDataOptions = ref([
  {
    label: "周一",
    value: "MONDAY",
  },
  {
    label: "周二",
    value: "TUESDAY",
  },
  {
    label: "周三",
    value: "WEDNESDAY",
  },
  {
    label: "周四",
    value: "THURSDAY",
  },
  {
    label: "周五",
    value: "FRIDAY",
  },
  {
    label: "周六",
    value: "SATURDAY",
  },
  {
    label: "周日",
    value: "SUNDAY",
  }
])

// 添加营业时间
const addOperatingTime = () => {
  ruleForm.operatingHours.push({
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null,
    operatingTime: []
  })
}
// 删除已填写的营业时间
const removeOperatingTime = (index) => {
  console.log("index", index)
  ruleForm.operatingHours.splice(index, 1)
  ruleFormRef.value.validateField("operatingHours")
}
// 判断营业结束时间选择范围
const handleWeekdayClose = (item, index) => {
  try {
    const findIndex = startDataOptions.value.findIndex(i => i.value === item.weekdayOpen)
    return index < findIndex
  } catch (e) {
    console.log(e)
    return false
  }
}
// 处理更改营业开始时间清空营业关闭时间
const handleClearClose = (index) => {
  ruleForm.operatingHours[index].weekdayClose = null
}

/*中英文切换输入框相关Tab*/
// 名称tab
const locationNameTab = ref("zh")
// 简称tab
const locationShortNameTab = ref("zh")
// 详细地址tab
const addressDetailTab = ref("zh")
// 描述tab
const descriptionTab = ref("zh")
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          :size="formSize"
          status-icon
          v-loading="loading"
      >
        <el-form-item label="名称：" prop="locationName">
          <el-tabs
              v-model="locationNameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.locationName" maxlength="40" placeholder="名称最长40个字" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.locationNameEn" maxlength="120" placeholder="The name should be up to 120 characters long" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="简称：" prop="locationShortName">
          <el-tabs
              v-model="locationShortNameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.locationShortName" maxlength="10" placeholder="简称最长10个字" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.locationShortNameEn" maxlength="30" placeholder="The name should be up to 30 characters long" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="类型：" prop="locationType" style="width: 250px;">
          <el-select v-model="ruleForm.locationType" placeholder="请选择" :disabled="isEdit">
            <el-option
                v-for="item in locationTypeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input style="width: 498px;" show-word-limit v-model="ruleForm.phone" maxlength="11" placeholder="请输入电话号码，座机/手机均可" />
        </el-form-item>
        <el-form-item label="所属区域：" prop="showAddressCode">
          <div class="w-100">
            <YTAddress style="width: 498px;" :addressCode="ruleForm.showAddressCode" :is-return-str="true" @select="handleSelectAddress"></YTAddress>
          </div>
        </el-form-item>
        <el-form-item label="详细地址：" prop="addressDetail">
          <el-tabs
              v-model="addressDetailTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="min-width: 498px;" v-model="ruleForm.addressDetail" placeholder="请填写详细地址（勿重复填写省市区）" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="min-width: 498px;" v-model="ruleForm.addressDetailEn" placeholder="Please fill in the detailed address (do not repeatedly fill in the province, city and district)" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="照片：" prop="pictures">
<!--          <BoxUpload ref="boxUploadRef" :pre-path="'store/'" @progress="loading = true" @success="handlePicSuccess" @remove="handlePicRemove" :limit="5"/>-->
          <BoxUpload
              ref="boxUploadRef"
              :limit="5"
              :fileSize="1"
              :aliOssPath="'SERVICE_LOCATION'"
              :isReplaceMode="false"
              :showFileList="false"
              :cache_type="false"
              @success="handlePicSuccess"
              @remove="handlePicRemove"
          ></BoxUpload>
        </el-form-item>
        <el-form-item label="营业时间：" prop="operatingHours">
          <div>
            <div class="flex_center mg_b_1" v-for="(item, index) in ruleForm.operatingHours" :key="`operatingHours${index}`">
              <div class="flex">
                <el-select
                    v-model="item.weekdayOpen"
                    placeholder="开始星期"
                    size="large"
                    style="width: 120px"
                    class="mg_r_1"
                    @change="handleClearClose(index)"
                >
                  <el-option
                      v-for="opt in startDataOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                  />
                </el-select>
                <span class="mg_r_1">
                至
              </span>
                <el-select
                    v-model="item.weekdayClose"
                    placeholder="结束星期"
                    size="large"
                    style="width: 120px"
                    class="mg_r_1"
                    :disabled="item.weekdayOpen === null"
                >
                  <el-option
                      v-for="(opt, optIndex) in startDataOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                      :disabled="handleWeekdayClose(item, optIndex)"
                  />
                </el-select>
              </div>
              <div class="flex mg_r_1">
                <el-time-picker format="HH:mm" class="mg_r_1" style="max-width: 150px" v-model="item.operatingTime[0]" placeholder="营业开始时间" />
                <div class="mg_r_1">至</div>
                <el-time-picker format="HH:mm" style="max-width: 150px" v-model="item.operatingTime[1]" placeholder="营业结束时间" />
              </div>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="删除"
                  placement="right">
                <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="removeOperatingTime(index)"></v-icon>
              </el-tooltip>
            </div>
            <div class="flex_left">
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="addOperatingTime"></v-icon>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="描述：" prop="description">
          <el-tabs
              v-model="descriptionTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input
                  v-model="ruleForm.description"
                  style="min-width: 498px"
                  :rows="5"
                  type="textarea"
                  maxlength="200"
                  resize="none"
                  show-word-limit
                  placeholder="最多200个字"
              />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input
                  v-model="ruleForm.descriptionEn"
                  style="min-width: 498px"
                  :rows="5"
                  type="textarea"
                  maxlength="600"
                  resize="none"
                  show-word-limit
                  placeholder="Up to 600 characters"
              />
            </el-tab-pane>
          </el-tabs>

        </el-form-item>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn @click="resetForm">取消</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" @click="submit">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </el-form>
    </v-container>
  </div>
</template>

<style scoped>

</style>
